
const BrandMission = () => {
  return (
    <section className="py-32 bg-white">
      <div className="container mx-auto px-6 max-w-6xl">
        <div className="text-center">
          <h2 className="text-6xl md:text-8xl font-serif font-light text-juv-deep-chestnut mb-12 tracking-tight">
            Beauty.<br />
            <span className="italic">Automated.</span>
          </h2>
          
          <p className="text-xl md:text-2xl text-juv-deep-chestnut/70 max-w-3xl mx-auto leading-relaxed font-light">
            At JUV, we've reimagined aesthetic wellness for the modern world. 
            Same-day treatments, transparent pricing, and results you can trust — 
            all powered by technology that puts you first.
          </p>
        </div>
      </div>
    </section>
  );
};

export default BrandMission;
